import { css } from "styled-components"

export const HeroOverlay = css`
  background-color: var(--tricorn-black);
  mix-blend-mode: multiply;
`
